
















































import {Component, Watch, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {$, Collection, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigWhatsapp from '@/model/resource/ResponsavelConfigWhatsapp'
import ResponsavelConfigWhatsappRequest from '@/model/request/ResponsavelConfigWhatsappRequest'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'
import {getResponsavel, ItrackCollection} from '@/helpers'
import * as Helper from '@/helpers'
import {cloneDeep, isEqual} from 'lodash'
import WhatsappStatus from '@/model/resource/WhatsappStatus'

const metaInfo = () => ({
  title: $.t('view.manage.whatsappNotificationSettings.title'),
})

@Component({
  metaInfo,
})
export default class ManageWhatsappNotificationsSettingsView extends Vue {
  @Action('auth/auth') auth!: Function
  @Getter('auth/responsavel') responsavelCache!: Responsavel

  AppConfig = AppConfig

  config = new ResponsavelConfigWhatsappRequest()
  configBeforeEdit: ResponsavelConfigWhatsappRequest | null = null
  possibleSmsStatus = new Collection(StatusSms)
  allTipoOcorrencia = ItrackCollection.allTipoOcorrencia
  ocorrencias = new Collection(TipoOcorrencia)

  async mounted() {
    await this.populateVariables()

    const filterNaoDevolvida = this.allTipoOcorrencia.items.filter((item) =>
      // @ts-ignore
      (item.responsavel.$id === getResponsavel().$id || !item.responsavel.$id))

    this.ocorrencias = Helper.collect(TipoOcorrencia, filterNaoDevolvida)
  }

  async populateVariables() {
    this.config.responsavel = this.responsavelCache.clone()
    await this.config.populate('load')
    this.configBeforeEdit = cloneDeep(this.config)
    await this.possibleSmsStatus.query()
    await this.allTipoOcorrencia.query()
  }

  addMsg() {
    this.config.list.push(new ResponsavelConfigWhatsapp())
  }

  removeMsg(i: number) {
    this.config.list.splice(i, 1)
  }

  async persist() {
    await this.validateFields()
    this.setEditedConfigsApprovalAsPending()

    await this.config.save()
    await this.auth()
    successAndPush('system.success.persist', 'cockpit')
  }

  async validateFields() {
    if (this.config.list.some((cfg) => !Boolean(cfg.status && cfg.status.idStatusPk))) {
      await Helper.abort('system.error.statusFieldCantBeEmpty')
    }
  }

  setEditedConfigsApprovalAsPending() {
    this.config.list.forEach((conf) => {
      const confBeforeEdit = this.configBeforeEdit && this.configBeforeEdit.list.find((cbe) => cbe.$id === conf.$id)

      if (!isEqual(conf, confBeforeEdit)) {
        conf.idWhatsappApprovalStatusFk = WhatsappStatus.PENDENTE
      }
    })
  }
}
